import { render, staticRenderFns } from "./AddSliderBanner.vue?vue&type=template&id=d7f560a4"
import script from "./AddSliderBanner.vue?vue&type=script&lang=js"
export * from "./AddSliderBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports